import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { PreviewProvider } from '@cms/runtime'
import App from './app/App'
import '@/styles/index.css'

// PreviewProvider is inert on the published site (it activates only inside the
// CMS preview iframe) so the hydrated markup matches the pre-rendered HTML.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <PreviewProvider>
        <App />
      </PreviewProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
